import {useSelector} from 'react-redux';
import {RootState} from '../store';
import {moneyFromMinor} from '../components/utils/UnitConversion.utils';

export const useWallet = () => {
  const walletData = useSelector((state: RootState) => state.auth.wallet);

  const tradeable = moneyFromMinor(walletData?.walletTradeableAmountMinor ?? 0);
  const withdrawable = moneyFromMinor(walletData?.walletWithdrawableAmountMinor ?? 0);
  const onHoldSale = moneyFromMinor(walletData?.walletOnHoldSaleAmountMinor ?? 0);
  const onHoldPurchase = moneyFromMinor(walletData?.walletOnHoldPurchaseAmountMinor ?? 0);

  return {
    walletStatus: walletData?.walletStatus ?? null,
    tradeable,
    withdrawable,
    onHoldSale,
    onHoldPurchase,
  };
};